<script setup lang="ts">
import {onMounted, ref} from 'vue'
import {findOcrTransaction} from '@/bank/ocrTransaction.service'

const props = defineProps({
    ocrTransactionUuid: {
        type: String,
        required: true
    }
})

const ocrTransaction = ref()

onMounted(async  () => {
    ocrTransaction.value = await findOcrTransaction(props.ocrTransactionUuid)
})
// TODO some elements
</script>

<template>
    <div>
        {{ props }}
    </div>
</template>

<style scoped>

</style>